import { type Html, html, View } from 'rune-ts';
import { find, isUndefined, pipe, throwIf } from '@fxts/core';
import type { IStoreRanking } from '@services/MarppleShop/features/Creator/type';
import { staticFont } from '@services/MarppleShop/shared/typography';
import { CreatorUtilS } from '@services/MarppleShop/features/Creator/outbound/share.ts';
import klass from './RankDiff.module.scss';

export interface RankDiffProps {
  ranking?: IStoreRanking | null;
  klass?: typeof klass;
  // default States 사용시 주입할 font
  font?: string;

  // custom states
  rank_diff_states?: {
    state: CreatorUtilS.DiffIconKey;
    makeHtml: (state: CreatorUtilS.DiffIconKey, diff: number) => Html;
  }[];
}

export class RankDiff extends View<RankDiffProps> {
  protected override template() {
    const style = this.data.klass ?? klass.rank_diff_of_creator_summary;
    return html` <div class="${style}">${this.makeRankDiffHtml()}</div> `;
  }

  private makeRankDiffHtml() {
    const { state, diff } = CreatorUtilS.getUpDownState(this.data.ranking);
    return pipe(
      this.rankDiffStates,
      find((change_state) => change_state.state === state),
      throwIf(isUndefined, () => console.error('올바른 랭킹 데이터가 아닙니다.', this.data.ranking)),
      (change_state) => change_state.makeHtml(state, diff),
    );
  }

  get rankDiffStates() {
    return this.data.rank_diff_states || this.defaultRankDiffStates;
  }

  private get defaultRankDiffStates(): {
    state: CreatorUtilS.DiffIconKey;
    makeHtml: (state: CreatorUtilS.DiffIconKey, diff: number) => Html;
  }[] {
    const { font = staticFont('unica_14_bold') } = this.data;
    return [
      {
        state: 'none',
        makeHtml() {
          return html``;
        },
      },
      {
        state: 'new',
        makeHtml(state) {
          return html` <div data-is-rank-new class="${font}">${CreatorUtilS.diffIcons[state]}</div> `;
        },
      },
      {
        state: 'up',
        makeHtml(state, diff) {
          return html`
            <div data-is-rank-up class="${font}">${CreatorUtilS.diffIcons[state]}${Math.abs(diff)}</div>
          `;
        },
      },
      {
        state: 'down',
        makeHtml(state, diff) {
          return html`
            <div data-is-rank-down class="${font}">${CreatorUtilS.diffIcons[state]}${Math.abs(diff)}</div>
          `;
        },
      },
      {
        state: 'zero',
        makeHtml() {
          return html``;
        },
      },
    ];
  }
}
